import {
    getPredefinedGroupLabel,
    groupAccountTypesByClass,
} from "@common/constants/domains/accounting/accountGroups";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { DropdownOption } from "./dropdownOption";

// Preserve exact types; groupKey keeps class headers stable through filtering.
export const buildAccountTypeCellOptions = ({
    accountTypes,
}: {
    accountTypes: AccountType[];
}): Array<DropdownOption<string>> =>
    groupAccountTypesByClass(accountTypes).flatMap(({ accountClass, types }) =>
        types.map((type, index) => ({
            value: type,
            label: getPredefinedGroupLabel(type),
            key: type,
            groupKey: accountClass,
            groupHeader: index === 0 ? accountClass : undefined,
        })),
    );
